import React from "react";
import { Link } from "react-router-dom";
import {
  FiInstagram,
  FiTwitter,
  FiFacebook,
  FiMail,
  FiPhone,
  FiMapPin,
  FiYoutube,
} from "react-icons/fi";
import "./Footer.css";
import logo from "../../assets/images/vedonicalogo1.png";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      {/* <div className="footer__wave">
        <svg
          viewBox="0 0 1440 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path
            d="M0 60L60 50C120 40 240 20 360 15C480 10 600 20 720 25C840 30 960 30 1080 25C1200 20 1320 10 1380 5L1440 0V60H0Z"
            fill="#0f5132"
          />
        </svg>
      </div> */}

      <div className="footer__body">
        <div className="container">
          <div className="footer__grid">
            <div className="footer__brand">
<h2>About Us</h2>
<h4>Welcome to Vedonica International Pvt. Ltd.</h4>

              <p className="footer__tagline">
 where ancient Ayurvedic wisdom meets modern science for everyday wellness. We believe in holistic health and create safe, effective, and easy-to-use products with carefully sourced herbs and uncompromised quality. Our mission is to bring natural balance and better health into your daily life.              </p>

              <div className="footer__social">
                <a
                  href="https://www.instagram.com/vedonica.in?igsh=MXVxbTJybjZ4Yjc3ZQ=="
                  target="_blank"
                  rel="noreferrer"
                  className="footer__social-link"
                  aria-label="Instagram"
                >
                  <FiInstagram />
                </a>
             <a
  href="https://youtube.com/@vedonica?si=u9HAyqYq24_zRHkD"
  target="_blank"
  rel="noreferrer"
  className="footer__social-link"
  aria-label="YouTube"
>
  <FiYoutube />
</a>
                <a
                  href="https://www.facebook.com/vedonica.in"
                  target="_blank"
                  rel="noreferrer"
                  className="footer__social-link"
                  aria-label="Facebook"
                >
                  <FiFacebook />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer__col">
              <h4 className="footer__col-title">Quick Links</h4>
             <ul className="footer__links">
  <li>
    <Link to="/" onClick={() => window.scrollTo(0, 0)}>Home</Link>
  </li>
  <li>
    <Link to="/" onClick={() => window.scrollTo(0, 0)}>Products</Link>
  </li>
  <li>
    <Link to="/vedoncia-international-blog">Blog</Link>
  </li>
  <li>
    <Link to="/dashboard?tab=orders">My Orders</Link>
  </li>
</ul>
            </div>

            {/* Account */}
            <div className="footer__col">
              <h4 className="footer__col-title">Account</h4>
           <ul className="footer__links">
  <li>
    <Link to="/login" onClick={() => window.scrollTo(0, 0)}>Login</Link>
  </li>
  <li>
    <Link to="/register" onClick={() => window.scrollTo(0, 0)}>Create Account</Link>
  </li>
  <li>
    <Link to="/dashboard" onClick={() => window.scrollTo(0, 0)}>Profile</Link>
  </li>
  <li>
    <Link to="/contactUs" onClick={() => window.scrollTo(0, 0)}>Contact Us</Link>
  </li>
</ul>
            </div>

            {/* Contact */}
            <div className="footer__col">
              <h4 className="footer__col-title">Contact</h4>
              <ul className="footer__contact">
                <li>
                  <FiMail size={15} />
                  <a href="mailto:vedonicainternational@gmail.com">
                    vedonicainternational@gmail.com
                  </a>
                </li>
                <li>
                  <FiPhone size={15} />
                  <a href="tel:+918368402126">+91 83684 02126</a>
                </li>
                <li>
                  <FiMapPin size={15} />
                  <span>
                    91, Saipuram Villa 2nd, Raj Nagar Extension, Uttar Pradesh -
                    201017
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer__bottom">
            <p>© {year} Vedonica International. All rights reserved.</p>
            <div className="footer__bottom-links">
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/terms-of-service">Terms of Service</a>
              <a href="/returns">Return Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
